import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { Z_LIST } from '../static/z';
import { imgs } from '../../../assets/dvWaterMarkImgs.js';

function logoWaterMarkParse(option: Parameters<ThemeParser>[0], themeMode: 'light' | 'dark') {
  option.dvWaterMark = util.merge(
    {
      id: '$DV_WATER_MARK',
      show: true,
      type: 'image',
      right: 24,
      bottom: 80,
      style: {
        width: 36,
        height: 10,
        image: imgs[themeMode]
      },
      z: Z_LIST.waterMark,
      silent: true
    },
    option.dvWaterMark || {},
    true
  );
}

export function graphicParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  logoWaterMarkParse(option, themeMode);
}
